import useInfrastructure from "hooks/useInfrastructure.hook";
import { useChatSelected } from "hooks/chat/useChatSelected.hook";

export function useChatLineSelected(id) {
  const { repositories } = useInfrastructure();
  const repository = repositories.lines;

  return useChatSelected({
    id,
    repository
  });
}